function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M19.46 4.39l-3.1-2.77a.89.89 0 00-.58-.22h-5V.87A.87.87 0 009 .87v6.06H4a.89.89 0 00-.58.22L.29 9.91a.87.87 0 00-.29.65.84.84 0 00.29.65L3.38 14a.85.85 0 00.62.2h5v4.69a.87.87 0 001.74 0V8.67h5a.89.89 0 00.58-.22l3.1-2.76a.91.91 0 00.33-.69.88.88 0 00-.29-.61zM9 12.46H4.29l-2.12-1.9 2.12-1.89H9zm6.45-5.53h-4.71V3.14h4.71L17.57 5z",
  fill: "#393c51",
  "data-name": "Capa 6"
}));

var SvgTour = function SvgTour(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.75 19.76"
  }, props), _ref);
};

export default SvgTour;